<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>      

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.unitId"
          v-bind="getObject('unitId')"
          label="Unidade"
          :items="extraData.globalContext.allUnits"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <UnitNew
              :inlineAddButton="true"
              @entry-created="unitCreated"
              withType="unit"
            />
          </template>
        </v-autocomplete>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import UnitNew from "@models/units/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    UnitNew: UnitNew,   
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    unitCreated: function(unit) {
      extraData.globalContext.allUnits.unshift(unit);
      this.entry.unitId = unit.id;
      this.entry.unit = unit;
    },
  }
};
</script>

<style scoped></style>
